import React from 'react';
import { Container, ThanksContainer, ThanksString, Sign, LinkStyled } from './styled/ThanksStyled';


const Thanks = (props) => {
    return (
        <div>
            <Container>
                <ThanksContainer>
                <ThanksString>Dziękujemy! </ThanksString>
                <Sign>Twoj głos został zapisany!</Sign>
                <LinkStyled to = "/petycja">Powróć do strony glównej</LinkStyled>
                </ThanksContainer>
            </Container>
        </div>
    )
}

export default Thanks;